export function notesDraftIsDirty(
  createText: string,
  isEditing: boolean,
): boolean {
  return createText.trim().length > 0 || isEditing
}

export function shouldHoldDialogOpen({
  nextOpen,
  isDirty,
  alreadyWarned,
}: {
  nextOpen: boolean
  isDirty: boolean
  alreadyWarned: boolean
}): { hold: boolean; warned: boolean } {
  if (nextOpen) return { hold: false, warned: false }
  if (isDirty && !alreadyWarned) return { hold: true, warned: true }
  return { hold: false, warned: alreadyWarned }
}

export function isComposerTrigger(target: EventTarget | null): boolean {
  return (
    target instanceof Element &&
    target.closest('[aria-controls="composer-root"]') !== null
  )
}
